import api from "../services/api";
import { AUTH_ACTIONS, buildAuthOverlayUrl } from "./authNavigation";
import { isInsufficientTalkBalanceError } from "./freemiumAccess";
import { showToast } from "./toast";

export { AUTH_ACTIONS };

export function isCustomerAuthed() {
  return Boolean(api.getToken?.());
}

export function openProtectedActionAuth(
  navigate,
  {
    basePath = "/",
    returnTo,
    caregiverId,
    action = AUTH_ACTIONS.HIRE,
    tab = "create",
    ...searchContext
  } = {}
) {
  const resolvedReturnTo = returnTo || basePath || "/";
  const overlayPath = basePath || resolvedReturnTo;
  const hireParam =
    action === AUTH_ACTIONS.HIRE || action === AUTH_ACTIONS.BOOK ? caregiverId : undefined;

  navigate(
    buildAuthOverlayUrl(overlayPath, {
      returnTo: resolvedReturnTo,
      action,
      caregiverId,
      hire: hireParam,
      tab,
      ...searchContext,
    })
  );
}

export function requireCustomerAuth(navigate, options) {
  if (isCustomerAuthed()) return true;
  openProtectedActionAuth(navigate, options);
  return false;
}

export function handleInsufficientCallCredits(err, navigate, authOptions = {}, ui = {}) {
  if (!isInsufficientTalkBalanceError(err)) return false;
  if (!isCustomerAuthed()) {
    showToast.info("You have used your free calls. Sign in to recharge and continue.");
    openProtectedActionAuth(navigate, {
      action: AUTH_ACTIONS.CALL,
      ...authOptions,
    });
    return true;
  }
  if (typeof ui.openExhausted === "function") {
    ui.openExhausted(err?.quota || err?.body?.quota || null);
    return true;
  }
  showToast.error(err?.message || "You have used your 3 free calls. Recharge to continue calling caregivers.");
  if (navigate && authOptions.navigateToCallHistory !== false) {
    navigate("/call-history");
  }
  return true;
}
